<script>
	import BoardHeader from '@/components/Board/BoardHeader.vue';
	import BoardCalendar from '@/components/Board/BoardCalendar.vue';
	import BoardProspect from '@/components/Board/BoardProspect.vue';
	import CardClient from '@/components/Board/CardClient.vue';
	import BoardClientActions from '@/components/Board/BoardClientActions.vue';

	export default {
		name: 'Board',
		components: {
			BoardHeader,
			BoardCalendar,
			BoardProspect,
			BoardClientActions,
			CardClient,
		},
		data () {
			return {
				clients: [],
				calendar : [],
			}
		},
	}
</script>

<template lang="html">
	<section class="dashboard">
		<BoardHeader />
		<BoardCalendar />
		<BoardClientActions />
		<BoardProspect />
	</section>
</template>

<style scoped>
/* DASHBOARD */
.dashboard {
	padding : 0 1.5rem;
	background-color: #F6F7F9;
	width: 100%;
	height: auto;
}
/* DASHBOARD HEADER*/
.dashboard_header {
	display: flex;
}
.dashboard_header__card{
	border-radius: 10px;
	background-color: #AF9376;
	padding: 2px;
	display: flex;
	gap: 1rem;
	color: #FFFFFF;
}
.dashboard__header__title, 
.dashboard__header__tagline
 {
	color: #ffffff;

}
.dashboard__header__title {
	font-size: 1.2rem;
	font-weight: bold;
}

.dashboard__header__tagline {
	font-size: 0.85rem;
	font-weight: normal;
}

.section_prospects {
	display: flex;
	gap: 2rem;
	justify-content: baseline;
	align-items: baseline;
	flex-wrap: wrap;
}
</style>


// WEBPACK FOOTER //
// Board.vue?bf340020